var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Echart',{style:({ height: _vm.curHeight + 'px', width: _vm.curWidth + 'px' }),attrs:{"options":_vm.options,"id":_vm.cdata.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }